module.exports = __webpack_public_path__ + "img/truck-flatbed.628b13b1.svg";